/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2026-09-10 13:57:07 */

const Keys = {
  showImage: 'showImage',
  showAllImages: 'showAllImages',
  roundView: 'roundView',
  layout: 'layout'
}; export default Keys;